.signet-button-group {
  display: flex;
  border-radius: 4px;
  width: fit-content;
  overflow: hidden;
  width: fit-content;
  border: 1px solid var(--primary-main);

  :not(:last-child) {
    border-right: 1px solid var(--primary-main) !important;
  }

  button {
    border-radius: 0px !important;
    box-shadow: none;
    border: 0;
    text-transform: none !important;
  }
}
